// Chef API service
import api from '../../services/api';

// Types
export interface ChefDashboardData {
  chef: {
    chef_id: number;
    name: string;
    email: string;
    slug: string;
    status: string;
    tier: string;
    recipe_rate: number;
    promo_code: string;
    code_uses: number;
    contract_end_date: string;
    terms_accepted_at: string | null;
  };
  recipes: {
    total: number;
    curated: number;
  };
  usage: {
    total_meal_appearances: number;
  };
}

export interface ChefRecipe {
  recipe_id: number;
  name: string;
  description: string | null;
  prep_time: number | null;
  cook_time: number | null;
  image_url: string | null;
  cuisine: string | null;
  servings: number | null;
  source_type: string | null;
  created_at: string;
  dietary_tags: string[] | null;
  meal_plan_count: number;
}

// API calls

export const getChefDashboard = async (): Promise<ChefDashboardData> => {
  const response = await api.get('/chefs/me/dashboard');
  return response.data.dashboard;
};

export const getChefRecipes = async (params?: {
  limit?: number;
  offset?: number;
}): Promise<ChefRecipe[]> => {
  const response = await api.get('/chefs/me/recipes', { params });
  return response.data.recipes;
};

export const acceptChefTerms = async (): Promise<{ terms_accepted_at: string }> => {
  const response = await api.post('/chefs/me/accept-terms');
  return response.data;
};
